import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IPromoCodesModel, IPromoDetails, IPromotionsModel } from './promotions.model';

@Injectable()
export class PromotionsService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'promos';

    /** GET */
    public getPromotions(eventId: string): Observable<SuccessResponse<IPromotionsModel> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IPromotionsModel>>(
                PromotionsService.URL +
                'events/' +
                `${eventId}` + '/' +
                PromotionsService.ENDPOINT
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getPromotion(eventId: string, promotionId: string): Observable<SuccessResponse<IPromoDetails> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<any>>(
                PromotionsService.URL +
                'events/' +
                `${eventId}` + '/' +
                PromotionsService.ENDPOINT + '/' +
                `${promotionId}`
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** PUT */
    public updatePromotionName(data: any, eventId: string, promotionId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .put<SuccessResponse<boolean>>(
                PromotionsService.URL +
                'events/' +
                `${eventId}` + '/' +
                PromotionsService.ENDPOINT + '/' +
                `${promotionId}`,
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public updatePromoCode(data: any, promoCodeId: string, promoId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .put<SuccessResponse<boolean>>(
                PromotionsService.URL +
                PromotionsService.ENDPOINT + '/' +
                `${promoId}` +
                '/promocodes' + '/' +
                `${promoCodeId}`,
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

     /** POST */
     public addPromotion(data: any, eventId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<boolean>>(
                PromotionsService.URL +
                'events/' +
                `${eventId}` + '/' +
                PromotionsService.ENDPOINT,
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public addPromoCodes(data: any, promoId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<boolean>>(
                PromotionsService.URL +
                PromotionsService.ENDPOINT + '/' +
                `${promoId}` +
                '/promocodes',
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getPromoCodes(data: any, promoId: string): Observable<SuccessResponse<IPromoCodesModel> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<IPromoCodesModel>>(
                PromotionsService.URL +
                PromotionsService.ENDPOINT + '/' +
                `${promoId}` +
                '/promocodes/index',
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** DELETE */
    public deletePromotion(eventId: string, promotionId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .delete<SuccessResponse<boolean>>(
                PromotionsService.URL +
                'events/' +
                `${eventId}` + '/' +
                PromotionsService.ENDPOINT + '/' +
                `${promotionId}`
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public deletePromoCode(promoId: string, promoCodeId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .delete<SuccessResponse<boolean>>(
                PromotionsService.URL +
                PromotionsService.ENDPOINT + '/' +
                `${promoId}` +
                '/promocodes' + '/' +
                `${promoCodeId}`
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

}
